import { useCallback } from 'react';
import { useCustomer } from '@app/user';
import { GTM } from '../clients';
import decorateAnalytics from '../redux/utils/decorateAnalytics';
import isGAReady from '../redux/utils/isGAReady';
import type { GATrackEventFunction } from '../types';

/**
 *
 */
const useGATrackEvent = () => {
  const customer = useCustomer();
  return useCallback<GATrackEventFunction>(
    (
      event = '',
      category = 'All',
      label = undefined,
      value = undefined,
      properties = {},
      decorators = {},
    ) => {
      const decoratorData = {
        customer,
        ...decorators,
      };

      // // GA events always need to be an int.
      let intVal: number | undefined;
      if (value) {
        intVal = Math.round(Number(value));
        if (!intVal) {
          intVal = undefined;
        }
      }

      //
      // Send all events to GTM.
      GTM.legacy({
        event,
        properties: {
          category,
          label,
          value: intVal,
          ...decorateAnalytics(decoratorData, 'gtm'),
          ...properties,
        },
      });

      if (isGAReady()) {
        // Note: We need to strip out any props that don't fit GA's custom prop format.
        const params = {
          eventAction: event,
          eventLabel: label,
          eventCategory: category,
          eventValue: intVal,
          ...decorateAnalytics(decoratorData, 'ga'),
          ...properties,
        };

        window.ga('send', {
          hitType: 'event',
          ...params,
        });
      }
    },
    [customer],
  );
};

export default useGATrackEvent;
